module.exports = __webpack_public_path__ + "img/gis_car_today.43dcbbaa.png";